export interface PendingParameters {
	groupSize?: number;
	date?: string;
	time?: string;
}

export type ParameterField = 'groupSize' | 'date' | 'time';

export interface ValidationResult {
	status: 'empty' | 'complete' | 'partial';
	errors: Partial<Record<ParameterField, string>>;
}

const ERROR_KEYS: Record<ParameterField, string> = {
	groupSize: 'errors.select_party_size',
	date: 'errors.select_date',
	time: 'errors.select_time'
};

export function validatePendingParameters(pending: PendingParameters): ValidationResult {
	const set = {
		groupSize: typeof pending.groupSize === 'number' && pending.groupSize > 0,
		date: !!pending.date,
		time: !!pending.time
	};
	const setCount = (Object.values(set) as boolean[]).filter(Boolean).length;
	if (setCount === 0) {
return { status: 'empty', errors: {} };
}
	if (setCount === 3) {
return { status: 'complete', errors: {} };
}
	const errors: ValidationResult['errors'] = {};
	(Object.keys(set) as ParameterField[]).forEach(k => {
 if (!set[k]) {
errors[k] = ERROR_KEYS[k];
}
});
	return { status: 'partial', errors };
}
